import { Component, HostListener, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { HeaderComponent } from "../../header/header.component";
import { FooterComponent } from '../../footer/footer.component';
import { CommonModule } from '@angular/common';
import { WebService } from '../../services/web.service';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { MetaTagService } from '../../meta-tag.service';
import { environment, GINConstants } from '../../../environments/environments';
import { IconsFreeToolsComponent } from '../../icons-free-tools/icons-free-tools.component';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-ai-thesis',
  standalone: true,
  imports: [HeaderComponent, CommonModule, HttpClientModule, FooterComponent, IconsFreeToolsComponent, FormsModule],

  templateUrl: './ai-thesis.component.html',
  styleUrl: './ai-thesis.component.css'
})
export class AiThesisComponent {
  shouldShowButton: boolean = false;
  activeTab: string = '';
  ngOnInit(): void {
    this.metaService.updateTags("Thesis Statement Generator  | Grammarin.com  ", "Thesis Statement Generator ", "https://www.grammarin.com/thesis-statement-generator");
    this.activeTab = 'q1';
  }
  constructor(private _webservice: WebService, @Inject(PLATFORM_ID) private platformID: Object, private httpClient: HttpClient, private metaService: MetaTagService) { }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public form_target: any;
  public form_detailed: any;

  public checkEmptyFields(form) {
    let emptyFields = [];
    if (form.form_target.trim() === '') {
      emptyFields.push('form_target');
    }
    if (form.form_detailed.trim() === '') {
      emptyFields.push('form_detailed');
    }
    return emptyFields;
  }
  public color: string = 'black';
  public esubText: string = '';
  public esubText2: string = '';
  eFsubText2: any;
  public loaderAlert: boolean = false;
  output: any;
  original: any;
  corrected: any;
  public eFsubIF: boolean = false;
  output_display = false;
  public eFormSubmission(event: any) {


    this.output_display = false;
    event.preventDefault();
    this.eFsubIF = false
    this.form_target = $('#form_target').val();
    this.form_detailed = $('#form_detailed').val();

    let form = {
      form_target: this.form_target,
      form_detailed: this.form_detailed
    };
    let emptyFields = this.checkEmptyFields(form);
    if (emptyFields.length > 0) {
      this.color = '#721c24';
      this.eFsubText2 = 'Please provide the required fields';
      emptyFields.forEach(function (field) {
        $('#' + field).css("border-color", "red");
      });
      this.eFsubIF = true
      $("#eFsubText2").show();
      setTimeout(function () {
        $("#eFsubText2").hide();
        emptyFields.forEach(function (field) {
          $('#' + field).css("border-color", "#08BA9C");
        });
        this.eFsubIF = false
      }, 3000);
    }
    else {
      this.loaderAlert = true;
      const headers = new HttpHeaders({
        'Authorization': environment.AuthorizationGIN,
      });
      this.httpClient.post(environment.API_URL + '/api/aiThesis', { 'target': this.form_target, 'detailed': this.form_detailed }, { headers }).subscribe(
        (response) => {

          this.output_display = true;
          this.output = response['output']
          this.loaderAlert = false;
          $('#form_target').css("border-color", "#08BA9C").css("background-color", "white");;;
          $('#form_detailed').css("border-color", "#08BA9C").css("background-color", "white");;;
        },
        (error) => {
          // console.error(error);
          this.output_display = true;
          this.loaderAlert = false;
          this.output = "Something went wrong. Please try again later."
          $('#form_target').val('').css("border-color", "#08BA9C");
          $('#form_detailed').val('').css("border-color", "#08BA9C");
        }
      );

    }
  }

  public copiedtext: boolean = false;
  public copried_txt: string = '';
  // copyToClipboard(): void {
  //   const textarea = document.createElement('textarea');
  //   textarea.value = this.output;
  //   document.body.appendChild(textarea);
  //   textarea.select();


  //   try {
  //     const successful = document.execCommand('copy');
  //     if (successful) {
  //       this.copiedtext = true;
  //       this.copried_txt = 'copied';
  //       $("#copytextId").hide();
  //       $("#copried_txt").show();


  //       setTimeout(() => {
  //         $("#copried_txt").hide();
  //         $("#copytextId").show();
  //         this.copiedtext = false;
  //       }, 2000);
  //     } else {
  //       // console.error('Failed to copy text');
  //       this.copiedtext = false;
  //     }
  //   } catch (err) {
  //     // console.error('Error copying text: ', err);
  //     this.copiedtext = false;
  //   } finally {
  //     document.body.removeChild(textarea); // Always remove the textarea from the DOM
  //   }
  // }

  copyToClipboard() {
    if (this.output) {

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.output;


      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(tempDiv);


      selection.removeAllRanges();
      selection.addRange(range);


      navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([tempDiv.innerHTML], { type: 'text/html' }),
          'text/plain': new Blob([tempDiv.innerText], { type: 'text/plain' })
        })
      ]).then(() => {
        this.copiedtext = true;
        setTimeout(() => {
          this.copiedtext = false;
        }, 2000);
      }).catch(err => console.error('Failed to copy:', err));


      selection.removeAllRanges();
    }
  }
  reFreshWindow() {
    window.location.reload();

  }

  uses = [
    {
      icon: 'enterTopic',
      title: 'Enter Your Topic',
      description: 'Start by entering the topic. It could be a phrase, keyword, or complete sentence.',
    },
    {
      icon: 'correctMistakesIcon',
      title: 'Enter Topic Details',
      description: 'Now, provide additional context about your assignment requirements, paper type, or specific angle you want.',
    },
    {
      icon: 'generateThesis',
      title: 'Generate Thesis',
      description: 'Click the “Generate Thesis” button, and your customized thesis statement appears within seconds.',
    },
  ];

  Formats = [
    {
      icon: 'argumentativeStatements',
      title: 'Argumentative Thesis Statements ',
      description: 'An argumentative thesis statement presents a clear stance on a debatable issue and aims to persuade the reader of that position. It often includes a claim and a brief outline of the supporting reasons.',
    },
    {
      icon: 'analyticalStatements',
      title: 'Analytical Thesis Statements ',
      description: 'Analytical thesis statements break down an idea or issue into its parts and evaluate them. This type of thesis tells the reader what aspect of the topic will be analyzed and the purpose of the analysis.',
    },
    {
      icon: 'expositoryStatements',
      title: 'Expository Thesis Statements ',
      description: 'An expository thesis statement aims to explain or inform the reader about a topic clearly and straightforwardly. It does not argue or analyze but instead outlines what will be explained.',
    },
    {
      icon: 'narrativeStatements',
      title: 'Narrative Thesis Statements ',
      description: 'Narrative thesis statements focus on telling a story, often from a personal perspective. Rather than making a claim or analyzing a topic, they set the stage for a narrative that conveys a central theme or lesson.',
    },
    {
      icon: 'informativeStatements',
      title: 'Informative Thesis Statements ',
      description: 'Informative thesis statements aim to educate readers on a particular subject by providing facts and insights. They are perfect for research papers and reports focused on factual presentation and audience education. ',
    },
  ];
  KeyFeatures = [
    {
      title: 'Step-by-step input process. ',
      detail:
        "The streamlined process captures every essential element without creating unnecessary complexity. Each input field targets specific information needed for accurate thesis generation, ensuring that every output directly addresses your unique requirements and academic goals.",
    },
    {
      title: 'Instant Thesis Generation ',
      detail:
        'AI-based algorithms quickly analyze your input and create clear, professional thesis statements in seconds. Get your thesis instantly ready for academic use and professor review.',
    },
    {
      title: 'Grammar and Clarity Optimisation ',
      detail:
        'A strong thesis needs more than just a good idea. The thesis must be clear and grammatically correct for the readers. Our Thesis Statement Generator helps you form a solid argument and ensures your statement is <a href="/grammar-checker" class="atag"> free from grammar and clarity mistakes </a>.',
    },
  ];
  activeIndex = 0;

  setActive(index: number): void {
    this.activeIndex = index;
  }
  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }
  selectedTab: string = 'tab1';
  selectTab(tab: string): void {

    this.selectedTab = tab;
  }
  selectTabImg(tab: string): void {

    this.selectedTab = tab;
  }
  getIcon(tab: string): string {
    return this.currentTab === tab
      ? '../../assets/images/free-grammarchecker/up arrow.svg'
      : '../../assets/images/free-grammarchecker/down arrow.svg';
  }
  currentTab: string = 'tab1';

  currenttoggleTab(tab: string): void {
    this.currentTab = this.currentTab === tab ? '' : tab;
  }

}
